<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addWines">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('wines')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    
    <!-- Modal de confirmação de exclusão -->
    <CModal
      :show.sync="showDeleteModal"
      :title="$t('confirmDelete')"
      color="primary"
    >
      <p>{{ $t('confirmRemove', { name: wineToDelete && wineToDelete.name ? wineToDelete.name : '' }) }}</p>
      <template #footer>
        <CButton @click="showDeleteModal = false" color="secondary">{{ $t('cancel') }}</CButton>
        <CButton @click="confirmDelete" color="primary" :disabled="deleting">
          <CSpinner v-if="deleting" size="sm" class="mr-1"></CSpinner>
          {{ $t('delete') }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'slug', label: i18n.t('slug'), sortable: true },
        { key: 'year', label: i18n.t('year'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'name', asc: true },
      loading: false,
      showDeleteModal: false,
      wineToDelete: null,
      deleting: false
    }
  },
  computed: {
    ...mapState('wines', ['getWinesOutput']),
    ...mapState('wines', ['deleteWineByIdOutput']),
    winesInfo: function() {
      return this.getWinesOutput ? this.getWinesOutput : null;
    },
    items: function()
    {
      return this.winesInfo && this.winesInfo.data ? this.winesInfo.data : [];
    },
    pages: function()
    {
      return this.winesInfo ? this.winesInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('wines', ['getWines']),
    ...mapActions('wines', ['deleteWineById']),
    rowClicked (item, index) {
      this.$router.push({name: "WinesEdit", query: { id: item.id }, params : { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "WinesEdit", query: { id: item.id }, params : { name: item.name } });
          break;
        }
        case 'remove':
        {
          this.openDeleteModal(item);
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      this.getWines(input); 
    },
    addWines () 
    {
      router.push({ name: 'WinesAdd'});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },
    openDeleteModal(item) {
      this.wineToDelete = item;
      this.showDeleteModal = true;
    },
    confirmDelete() {
      if (!this.wineToDelete) return;
      
      this.deleting = true;
      this.deleteWineById(this.wineToDelete.id);
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteWineByIdOutput: function(val)
    {
      this.loading = true;
      this.deleting = false;
      this.showDeleteModal = false;
      this.wineToDelete = null;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getWinesOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 